import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GonvarriOrderSummaryComponent} from '../../components/gonvarri-order-summary/gonvarri-order-summary.component';
import {GonvarriCartSharedModule} from "../gonvarri-cart-shared-module/gonvarri-cart-shared-module.module";
import {FeaturesConfigModule, I18nModule} from "@spartacus/core";
import {CartCouponModule} from "@spartacus/cart/base/components";
import {provideOutlet} from "@spartacus/storefront";
import {CartOutlets} from "@spartacus/cart/base/root";
import {ActiveCartService} from "@spartacus/cart/base/core";
import {GonvarriActiveCartService} from "../../core/services/gonvarri-active-cart.service";
import {GonvarriCartOutlets} from "../../core/models/gonvarri-cart-outlets.model";


@NgModule({
  declarations: [
    GonvarriOrderSummaryComponent
  ],
  exports: [
    GonvarriOrderSummaryComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    CartCouponModule,
    FeaturesConfigModule
  ],
  providers: [
    provideOutlet({
      id: GonvarriCartOutlets.GONVARRI_ORDER_SUMMARY,
      component: GonvarriOrderSummaryComponent,
    }),
    {
      provide: ActiveCartService,
      useClass: GonvarriActiveCartService
    },
  ]
})
export class GonvarriOrderSummaryModule {
}
